import { Stack, styled } from '@mui/material';
import { ReactNode } from 'react';

import EntityViewBlock from './EntityViewBlock';
import EntityViewTextValueRow from './EntityViewTextValueRow';

export interface InfoLineProps {
    /**
     * Icon displayed at the start of the line
     */
    icon?: ReactNode;
    /**
     * Title/label for the info line
     */
    title: string;
    /**
     * Description or value text
     */
    description?: string | null;
    /**
     * Content displayed at the end of the line (e.g., status indicator, action button)
     */
    trailing?: ReactNode;
}

export default function InfoLine({ icon, title, description, trailing }: InfoLineProps) {
    return (
        <InfoLineRoot>
            { icon }
            <StyledEntityViewBlock title={ title }>
                <EntityViewTextValueRow text={ description } />
            </StyledEntityViewBlock>
            { trailing }
        </InfoLineRoot>
    );
}

const InfoLineRoot = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(3),
    padding: theme.spacing(3, 4),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.subtle,

    svg: {
        fontSize: theme.spacing(5),
        color: theme.palette.text.secondary
    }
}));

const StyledEntityViewBlock = styled(EntityViewBlock)({
    flex: 1
});
